module.exports = __webpack_public_path__ + "img/maisonette-3.3f9cc8b9.webp";